<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane label="Published" name="A"></el-tab-pane>
      <el-tab-pane label="Drafts" name="P"></el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-6">
            Products
          </div>
          <div class="col-6">
            <product-create v-if="$store.getters.isAdmin" />
          </div>
        </div>
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Product</th>
              <th>Brand</th>
              <th v-if="$store.getters.isAdmin">Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td>
                <strong><router-link :to="{ name: 'products-id', params: { id: product.id } }">{{ product.title }}</router-link></strong><br>
                <router-link :to="{ name: 'categories-id', params: { id: product.category.id } }">{{ product.category.title }}</router-link>
              </td>
              <td>
                <router-link :to="{ name: 'brands-id', params: { id: product.brand.id } }">{{ product.brand.name }}</router-link><br>
                {{ product.series }}
              </td>
              <td v-if="$store.getters.isAdmin">
                <product-view v-if="product.status === 'A'" :product="product" />
                <product-publish v-else :productId="product.id" @update="getProducts" />
                <product-delete :productId="product.id" @delete="getProducts" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCreate from '@/components/Product/ProductCreate'
import ProductView from '@/components/Product/ProductView'
import ProductPublish from '@/components/Product/ProductPublish'
import ProductDelete from '@/components/Product/ProductDelete'

export default {
  data() {
    return {
      loading: true,
      activePane: 'A',
      products: [],
    }
  },

  components: {
    ProductCreate,
    ProductView,
    ProductPublish,
    ProductDelete,
  },

  mounted() {
    this.getProducts()
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getProducts()
    },

    async getProducts() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/products`, {
          params: {
            status: this.activePane,
            limit: 512,
          },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.products = data
    },
  },
}
</script>
